/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { CashHistorialFiltersPanel } from '../CashHistorialFiltersPanel';
import type { CashVm } from './cashManagement.types';
import { formatHistoryRangeLabel } from './cashManagement.utils';

type Props = {
  vm: CashVm;
  onOpenCustomModal: () => void;
  workspaceMode?: boolean;
  compact?: boolean;
  onOpenFiltersModal?: () => void;
  filtersInModal?: boolean;
};

export function CashHistorialFiltersBlock({
  vm,
  onOpenCustomModal,
  workspaceMode,
  compact,
  onOpenFiltersModal,
  filtersInModal,
}: Props) {
  return (
    <CashHistorialFiltersPanel
      historyRangePreset={vm.historyRangePreset}
      onHistoryRangePresetChange={vm.setHistoryRangePreset}
      historyRangeLabel={formatHistoryRangeLabel(vm.historyQueryRange.fromIso, vm.historyQueryRange.toIso)}
      onOpenCustomModal={onOpenCustomModal}
      operatorFilter={vm.operatorFilter}
      onOperatorFilterChange={vm.setOperatorFilter}
      operatorOptions={vm.operatorOptions}
      differenceFilter={vm.differenceFilter}
      onDifferenceFilterChange={vm.setDifferenceFilter}
      historySort={vm.historySort}
      onHistorySortChange={vm.setHistorySort}
      workspaceMode={workspaceMode}
      compact={compact}
      onOpenFiltersModal={onOpenFiltersModal}
      hideTitle={filtersInModal}
      sheetMode={filtersInModal}
    />
  );
}
